<template>
	<div>
		<!-- header -->
		<div :class="isPc == true ? 'headerbg' : 'headerbg-mob'">
			<div v-if="setting" :class="isPc == true ? 'header_logo warp' : 'header_logo-mob warp-mob'">
				<img class="logo" :src="setting.logo" />
				<img class="logotext" :src="setting.text_logo" />
				<div v-if="isPc == false" class="serchbox">
					<input type="text" placeholder="输入要查找的内容" v-model="search_keywords" />
					<img @click="fuzzySearch()" src="../static/imgs/组 4.png" />
				</div>
			</div>
		</div>

		<div v-if="navList" :class="isPc == true ? 'header_nav' : 'header_nav-mob'">
			<div v-show="isPc == false" id="nav" style="display: flex">
				<img style="width: 18px; height: 18px; margin: 11px 16px" @click="goindex()" src="../static/imgs/1.png" />
				<div class="header_nav_list-mob" @click="goothers(item.path)" v-for="(item, index) in navList" :key="index">
					<div class="header_nav-mob_item">{{ item.name }}</div>
				</div>
			</div>

			<ul v-if="isPc == true" class="header_nav_list warp">
				<img class="header_nav_home" @click="goindex()" src="../static/imgs/1.png" />

				<div style="width: 1000px; height: 50px">
					<div class="horizontal-container">
						<div class="scroll-wrapper" style="background-image: none; overflow-x: auto" ref="scroll" id="scroll">
							<div class="scroll-content">
								<div class="scroll-item" style="color: #fff" @click="goothers(item.path)" v-for="(item, index) in navList" :key="index">
									<p>{{ item.name }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="serchbox">
					<input type="text" placeholder="输入要查找的内容" v-model="search_keywords" />
					<img @click="fuzzySearch()" src="../static/imgs/组 4.png" />
				</div>
			</ul>
		</div>

		<MobHeader v-if="isPc == false"></MobHeader>

		<div v-if="isPc == true && setting" class="noticebox warp">
			<img class="noticebox_icon" src="../static/imgs/gonggao.png" />
			<div class="noticebox_date">
				<p>{{ time_text }}</p>
			</div>
			<div v-if="air_temperature != '*'" class="noticebox_weather">{{ address }} {{ weather }} {{ air_temperature }}°C</div>
			<div class="noticebox_contact">
				<img src="../static/imgs/dianhua.png" />
				<p class="greyfont">
					预约及咨询电话:
					<span v-if="setting" class="bluefont">{{ setting.phone_number }}</span>
				</p>
				<p class="lightgrayfont" style="font-style: italic">{{ setting.and_time }}</p>
			</div>
		</div>

		<!-- content内容 -->
		<router-view style="margin-top: 20px" :key="$route.fullPath" />

		<!-- footer -->
		<div v-if="isPc == true" class="footer">
			<div class="footer_link bluefont">
				<ul class="warp">
					<li v-for="(item, index) in linkList" :key="index">
						{{ item.name }}
						<p v-if="linkList.length - index > 1">/</p>
					</li>
				</ul>
			</div>
			<div class="footer_info">
				<div class="footer_info_list warp">
					<img v-if="setting" class="footer_info_list_logo" :src="setting.logo" alt="logo" />
					<div v-if="setting" class="footer_info_list_text">
						<p>{{ setting.copyright }}</p>
						<p>地址:{{ setting.address }}</p>
						<p>邮编:{{ setting.postal_code }} 传真:{{ setting.fax }}</p>
						<p>邮箱:{{ setting.mailbox }}</p>
					</div>
					<div v-if="setting" class="footer_info_list_link">
						<div v-if="setting.we_chat_official_account">
							<img :src="setting.we_chat_official_account" alt="微信公众平台" />
							<!-- <p @click="gocenter()">微信公众平台</p> -->
							<p>微信公众平台</p>
						</div>
						<div v-if="setting.service_system_platform">
							<img :src="setting.service_system_platform" alt="服务系统平台" />
							<p>服务系统平台</p>
						</div>
						<div v-if="setting.sina_weibo">
							<img :src="setting.sina_weibo" alt="新浪微博" />
							<p>新浪微博</p>
						</div>
					</div>
				</div>
			</div>
			<div class="footer_filing">
				<div class="footer_filing_warp warp">
					<p v-if="setting">{{ setting.beian2 }}</p>
					<p v-if="setting">工信部备案号:{{ setting.beian }}</p>
					<p v-if="friendly_links">
						友情链接:
						<span v-for="(item, index) in friendly_links" :key="index" style="margin-left: 5px">
							<a :href="item" target="_blank" style="color: #fff">{{ index }}</a>
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BScroll from '@better-scroll/core';
import Swiper from 'swiper';
import MobHeader from '../components/mob-header.vue';

export default {
	name: 'WebLijinhospitalLayout',
	components: {
		MobHeader
		// ScrollView
	},
	data() {
		return {
			isDrag: false, //是否在拖拽
			isClick: false, //是否是单击
			isPc: true,
			navList: null,
			linkList: [
				{ name: '医院文化', path: '/aboutHospital' },
				{ name: '职工天地', path: '/manageHospital' },
				{ name: '医疗保险', path: '/aboutHospital' },
				{ name: '药事管理', path: '/aboutHospital' },
				{ name: '医院感染管理', path: '/aboutHospital' },
				{ name: '信息公开', path: '/aboutHospital' },
				{ name: '投诉电话', path: '/aboutHospital' }
			],
			List: [
				{ name: '医院文化', path: '/aboutHospital' },
				{ name: '职工天地', path: '/manageHospital' },
				{ name: '医疗保险', path: '/aboutHospital' },
				{ name: '药事管理', path: '/aboutHospital' },
				{ name: '医院感染管理', path: '/aboutHospital' },
				{ name: '信息公开', path: '/aboutHospital' },
				{ name: '投诉电话', path: '/aboutHospital' },
				{ name: '医院文化', path: '/aboutHospital' },
				{ name: '职工天地', path: '/manageHospital' },
				{ name: '医疗保险', path: '/aboutHospital' },
				{ name: '药事管理', path: '/aboutHospital' },
				{ name: '医院感染管理', path: '/aboutHospital' },
				{ name: '信息公开', path: '/aboutHospital' },
				{ name: '投诉电话', path: '/aboutHospital' },
				{ name: '医院文化', path: '/aboutHospital' },
				{ name: '职工天地', path: '/manageHospital' },
				{ name: '医疗保险', path: '/aboutHospital' },
				{ name: '药事管理', path: '/aboutHospital' },
				{ name: '医院感染管理', path: '/aboutHospital' },
				{ name: '信息公开', path: '/aboutHospital' },
				{ name: '投诉电话', path: '/aboutHospital' }
			],
			setting: null,
			time_text: '',
			address: '*',
			weather: '*',
			air_temperature: '*',
			friendly_links: null,
			search_keywords: ''
		};
	},

	beforeCreate() {},

	mounted() {
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		window.onresize = () => {
			this.screenWidth = document.body.clientWidth;
			if (this.screenWidth <= 820) {
				this.isPc = false;
			} else {
				this.isPc = true;
			}
		};
		// navList
		let _t = this;
		this.$axios({
			url: 'http://www.ljxzxyy.cn/api/index/article'
		})
			.then((response) => {
				//请求成功
				console.log('article', response.data);
				let newnavList = [];
				for (var i = 0; i < response.data.data.length; i++) {
					newnavList[i] = {
						name: response.data.data[i]['name'],
						path: '/' + response.data.data[i]['flag'] + '?id=' + response.data.data[i]['id'] + '&name=' + response.data.data[i]['name']
					};
				}
				_t.navList = newnavList;
				console.log('_t.navList', _t.navList);
			})
			.catch((error) => {
				//请求失败
				console.log('article', error);
			});
		// Swiper
		new Swiper('.swiper-container', {
			//direction: 'vertical', // 垂直切换选项
			loop: true, // 循环模式选项

			// 如果需要分页器
			pagination: {
				el: '.swiper-pagination'
			}
		});
		this.$axios({
			url: 'http://www.ljxzxyy.cn/api/index/getsetting'
		})
			.then((response) => {
				//请求成功
				console.log('getsetting', response.data);
				this.setting = response.data.data;
				this.friendly_links = JSON.parse(this.setting.friendly_links);
				console.log('friendly_links', this.friendly_links);
			})
			.catch((error) => {
				//请求失败
				console.log('getsetting', error);
			});
		this.$axios({
			url: 'http://www.ljxzxyy.cn/api/index/getweather'
		})
			.then((response) => {
				//请求成功
				console.log('getweather', response.data);
				this.address = response.data.data.weather[0]['city'];
				this.weather = response.data.data.weather[0]['weather'];
				this.air_temperature = response.data.data.weather[0]['temperature'];
				console.log('asiudgfoiuagsdofiugoasiudhfiu', this.weather);
			})
			.catch((error) => {
				//请求失败
				console.log('getweather', error);
			});
		let week_text = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
		let new_date = new Date();
		this.time_text = new_date.getFullYear() + '年' + (new_date.getMonth() - -1) + '月' + new_date.getDate() + '日 ' + week_text[new_date.getDay()];
		// this.$axios({
		// 	url: 'http://www.ljxzxyy.cn/api/index/ip'
		// })
		// 	.then((response) => {
		// 		//请求成功
		// 		console.log('ip', response.data);
		// 		this.address = response.data.data.ip.data.city;
		// 	})
		// 	.catch((error) => {
		// 		//请求失败
		// 		console.log('ip', error);
		// 	});
	},
	watch: {
		navList(n, o) {
			if (o == null) {
				this.$nextTick(function () {
					if (this.isPc) {
						this.pcScroll();
						this.init();
					} else {
						this.scrollInit();
					}
				});
			}
		}
	},
	methods: {
		pcScroll() {
			console.log('pcScroll');
			// 获取要绑定事件的元素
			var nav = document.getElementById('scroll');
			var flag; // 鼠标按下
			var downX; // 鼠标点击的x下标
			var scrollLeft; // 当前元素滚动条的偏移量
			nav.addEventListener('mousedown', function (event) {
				flag = true;
				downX = event.clientX; // 获取到点击的x下标
				scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
			});
			nav.addEventListener('mousemove', function (event) {
				if (flag) {
					// 判断是否是鼠标按下滚动元素区域
					var moveX = event.clientX; // 获取移动的x轴
					var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
					this.scrollLeft = scrollLeft - scrollX; // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
					console.log(scrollX);
				}
			});
			// 鼠标抬起停止拖动
			nav.addEventListener('mouseup', function () {
				flag = false;
			});
			// 鼠标离开元素停止拖动
			nav.addEventListener('mouseleave', function () {
				flag = false;
			});
		},
		goindex() {
			this.$router.push('/index');
		},
		goothers(e) {
			this.$router.push(e);
			// console.log(item)
		},
		// 手机端拖拽功能
		scrollInit() {
			// 获取要绑定事件的元素
			var nav = document.getElementById('nav');
			var flag; // 鼠标按下
			var downX; // 鼠标点击的x下标
			var scrollLeft; // 当前元素滚动条的偏移量
			nav.addEventListener('mousedown', function (event) {
				flag = true;
				downX = event.clientX; // 获取到点击的x下标
				scrollLeft = this.scrollLeft; // 获取当前元素滚动条的偏移量
			});
			nav.addEventListener('mousemove', function (event) {
				if (flag) {
					// 判断是否是鼠标按下滚动元素区域
					var moveX = event.clientX; // 获取移动的x轴
					var scrollX = moveX - downX; // 当前移动的x轴下标减去刚点击下去的x轴下标得到鼠标滑动距离
					this.scrollLeft = scrollLeft - scrollX; // 鼠标按下的滚动条偏移量减去当前鼠标的滑动距离
					console.log(scrollX);
				}
			});
			// 鼠标抬起停止拖动
			nav.addEventListener('mouseup', function () {
				flag = false;
			});
			// 鼠标离开元素停止拖动
			nav.addEventListener('mouseleave', function () {
				flag = false;
			});
		},

		// // pc端拖拽功能
		// handlemouse(e){
		// 	let startTime,endTime;
		// 	let child=document.getElementById('parent');
		// 	let parent=document.getElementById('grand');
		// 	// 使用this.$refs.name获取dom元素,可能会获取到vue组件,他不支持获取元素的宽高以及监听鼠标事件
		// 	let widthDiffer=parent.offsetWidth - child.offsetWidth;
		// 	if(widthDiffer>0){
		// 		//如果grand真实宽度比parent宽度长,那么就不用滑动了,直接返回
		// 		this.isClick=true;
		// 		return
		// 	}
		// 	startTime=new Date().getTime();//获取事件开始时间
		// 	let disx= e.clientX - child.offsetLeft;
		// 	this.isDrag=true;//设置开始拖拽
		// 	parent.onmousemove =(e)=>{
		// 	if(this.isDrag){//拖拽中
		// 		let mouseX=e.clientX; // 鼠标点击的位置
		// 		let x=mouseX-disx;
		// 		child.style.left=x+'px'//设置parent的位置
		// 	}
		// 	}
		// 	parent.onmouseup=()=>{
		// 	endTime=new Date().getTime();
		// 	let timeDiffer=endTime-startTime;//获取抬起时间
		// 	this.isDrag=false;
		// 	if(timeDiffer<150){
		// 		//时间间隔小于150,那么就判断为单击事件,这里时间间隔可自由设置
		// 		this.isClick=true;
		// 	}else{
		// 		this.isClick=false;
		// 	}
		// 	}
		// }
		init() {
			this.bs = new BScroll(this.$refs.scroll, {
				scrollX: true,
				probeType: 3 // listening scroll event
			});
			this.bs.on('scrollStart', () => {
				console.log('scrollStart-');
			});
			this.bs.on('scroll', () => {
				console.log('scrolling-');
			});
			this.bs.on('scrollEnd', () => {
				console.log('scrollingEnd');
			});
		},
		fuzzySearch: function () {
			this.$router.push('/managequality?key=' + this.search_keywords);
		}
	},
	computed: {}
};
</script>

<style>
@import url('../static/css/style.css');
* {
	margin: 0;
	padding: 0;
}

.headerbg {
	width: 100%;
	height: 20vh;
	min-width: 1220px;
	margin: 0 auto;
	background: url('../static/imgs/组 3.png') no-repeat;
	background-size: 100% 100%;
}
.header_logo {
	height: 100%;
	display: flex;
	align-items: center;
}
.logo {
	margin-left: 40px;
	width: 100px;
	height: 100px;
}
.logotext {
	width: 400px;
	height: 65px;
	margin-left: 30px;
}

.header_nav {
	width: 100%;
	min-width: 1220px;
	background-color: #0e6baf;
}
.header_nav-mob {
	width: 100%;
	background-color: #0e6baf;
}
.header_nav_list {
	height: 50px;
	display: flex;
	align-items: center;
	position: relative;
}
.header_nav_home {
	margin-right: 10px;
	cursor: pointer;
}
.header_nav_item {
	width: 80px;
	height: 23px;
	font-size: 15px;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	border-left: 1px solid #1a79bc;
	cursor: pointer;
}
.serchbox {
	width: 165px;
	height: 35px;
	background-color: white;
	position: absolute;
	right: 0;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 5px;
}
.serchbox input {
	border: none;
	width: 110px;
	margin-left: 10px;
}
.serchbox input::-webkit-input-placeholder {
	font-size: 13px;
	color: #cdcdcd;
	border: none;
}
.serchbox input[type='text']:focus {
	outline: none;
}
.serchbox img {
	width: 35px;
	height: 35px;
	cursor: pointer;
}

.header_nav_navlist {
}
.header_nav_navlist::-webkit-scrollbar {
	display: none;
}

.headerbg-mob {
	width: 100%;
	height: 30vh;
	background: url('../static/imgs/bgimg-mob.png') no-repeat;
	background-size: 100% 100%;
}
.header_logo-mob {
	height: 0.8rem;
	display: flex;
	align-items: center;
	position: relative;
}
.header_logo-mob .logo {
	margin: 0;
	width: 0.4rem;
	height: 0.4rem;
}
.header_logo-mob .logotext {
	width: 1.3rem;
	height: 0.25rem;
	margin-left: 10px;
	margin-top: 5px;
}
.header_logo-mob .serchbox {
	width: 2.6rem;
	height: 0.4rem;
	border-radius: 2px;
	position: absolute;
	right: 0;
}
.header_logo-mob .serchbox img {
	height: 0.4rem;
	width: 0.4rem;
}

#nav {
	overflow-x: auto;
	overflow-y: hidden;
}
.header_nav_list-mob {
	height: 0.6rem;
	display: flex;
	align-items: center;
}
.header_nav-mob_item {
	font-size: 0.15rem;
	width: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	color: white;
	border-left: 1px solid #1a79bc;
}

.noticebox {
	margin-top: 20px;
	height: 50px;
	background-color: #f7f7f7;
	display: flex;
	align-items: center;
}

.noticebox_icon {
	margin-left: 10px;
}

.noticebox_date {
	margin-left: 10px;
	padding-left: 20px;
	height: 23px;
	display: flex;
	align-items: center;
	border-left: 2px solid #cccccc;
	font-size: 16px;
	color: #000;
	font-family: '黑体';
	font-weight: bold;
}

.noticebox_weather {
	margin-left: 50px;
	font-size: 16px;
}

.noticebox_contact {
	display: flex;
	align-items: center;
	margin-left: 280px;
	font-size: 14px;
}

.noticebox_contact p {
	margin-left: 20px;
}

.noticebox_contact p span {
	font-size: 16px;
	font-weight: bold;
	font-style: italic;
	margin-left: 20px;
}

.footer {
	margin-top: 60px;
	width: 100%;
	min-width: 1220px;
	height: 330px;
}
.footer-mob {
	margin-top: 60px;
	width: 100%;
	height: 330px;
}

.footer_link {
	width: 100%;
	height: 80px;
	background-color: #ebf5fc;
	border-bottom: 2px solid #0e6baf;
}

.footer_info {
	height: 200px;
	width: 100%;
	background-color: #ebf5fc;
}

.footer_filing {
	width: 100%;
	height: 60px;
	background-color: #0e6baf;
}

.footer_link ul {
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}

.footer_link ul li {
	display: flex;
	font-size: 14px;
}

.footer_link ul li p {
	margin-left: 30px;
	margin-right: 30px;
}

.footer_info_list {
	display: flex;
	align-items: center;
	height: 200px;
}

.footer_info_list_logo {
	width: 100px;
	height: 100px;
	margin-left: 50px;
}

.footer_info_list_text {
	margin-left: 50px;
	font-size: 14px;
	height: 100px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}

.footer_info_list_link {
	height: 100px;
	display: flex;
	align-items: flex-end;

	margin-left: 80px;
}

.footer_info_list_link div {
	margin-left: 50px;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.footer_info_list_link div img {
	width: 70px;
	height: 70px;
}

.footer_info_list_link div p {
	font-size: 12px;
	margin-top: 10px;
}

.footer_filing_warp {
	width: 55%;
	height: 60px;
	display: flex;
	align-items: center;
	justify-content: space-around;
	font-size: 12px;
	color: #fff;
}
.scroll-wrapper::-webkit-scrollbar {
	width: 0 !important;
}
</style>
